// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1_ebv","detailsBorder":"styles_detailsBorder__3S6iR"};